// HITL-1749: the `info_slash_commands` options, kept free of imports so
// the config selectors can read them without pulling in the menu modules.

// Category of every generated `/info_*` item. Starts with '/', so a pick goes
// down the slash-command path; also how search tells the answers apart.
export const INFO_SLASH_COMMAND_CATEGORY = '/info';

// null = the feature is off for this store.
export type InfoSlashCommandOptions = { exclude: string[] } | null;

/**
 * The exclude list for this store from the flag's variant payload: JSON keyed
 * by a piece of the restaurant code (`{"dq_": {"exclude": ["sizes_info"]}}`);
 * the longest key found anywhere in the code wins. Contains, not starts-with:
 * production DQ codes start with `dq_`, but internal ones only carry
 * `dairy_queen` somewhere (`presto_dairy_queen_lab`,
 * `mot_staging_dairy_queen_2`). Anything unreadable excludes nothing, so a
 * bad payload never takes the feature down.
 */
export const resolveInfoSlashCommandExclude = (
  payload: string | undefined,
  restaurantCode: string | undefined
): string[] => {
  if (!payload || !restaurantCode) return [];
  try {
    const byCodePart = JSON.parse(payload);
    if (!byCodePart || typeof byCodePart !== 'object') return [];
    const code = restaurantCode.toLowerCase();
    const match = Object.keys(byCodePart)
      .filter((key) => key && code.includes(key.toLowerCase()))
      .sort((a, b) => b.length - a.length)[0];
    const exclude = match ? byCodePart[match]?.exclude : undefined;
    return Array.isArray(exclude)
      ? exclude.filter((key): key is string => typeof key === 'string')
      : [];
  } catch {
    return [];
  }
};
